<template>
    <header class="content-header" :class="{ 'content-header--bordered': bordered }">
        <slot name="custom-back"></slot>
        <router-link
            v-if="backLink"
            :to="backLink"
            v-text="backLinkTitle ? backLinkTitle : 'back'"
            class="content-header__breadcrumb"
        />
        <div class="content-header__inner">
            <div class="content-header__title">
                <span class="h1">{{ title }}<slot name="title-extra"></slot></span>
                <p v-text="subTitle" v-if="subTitle" />
            </div>
            <div class="content-header__actions">
                <slot name="actions"></slot>
            </div>
        </div>
        <div class="content-header__extra"><slot name="extra"></slot></div>
    </header>
</template>
<script>
export default {
    name: 'ContentHeader',
    props: {
        backLink: {
            type: String,
            default: null,
        },
        backLinkTitle: {
            type: String,
            default: null,
        },
        title: {
            type: String,
            required: true,
        },
        subTitle: {
            type: String,
            default: null
        },
        enableSearch: {
            type: Boolean,
            default: false,
        },
        bordered: {
            type: Boolean,
            default: true,
        }
    },
}
</script>
<style lang="scss" scoped>
@import '~@/theme/_variables.scss';

.content-header {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 3rem;
    width: 100%;

    .content-header__breadcrumb {
        font-size: 1.2rem;
        line-height: 1.4rem;
        margin-bottom: .7rem;
    }

    .content-header__inner {
        display: flex;
        align-items: flex-end;
        width: 100%;

        .content-header__title {
            flex: 1 1 auto;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            column-gap: 1rem;

            .h1 {
                display: flex;
                align-items: flex-start;
                column-gap: 1rem;
            }

            > * {
                margin-bottom: 0;
            }

            p {
                font-size: 1.6rem;
                line-height: 2.2rem;
                color: #747484;
            }
        }

        .content-header__actions {
            flex: 1 1 0;
            display: flex;
            justify-content: flex-end;
            position: relative;
            //bottom: .5rem;
        }

        &:first-child {
            margin-top: 2.1rem;
        }
    }

    .content-header__extra {
        margin-top: 1rem;

        &:empty {
            display: none;
        }
    }

    .btn--primary {
        width: 23rem;

        @media screen and (max-width: 991px){
            width: auto;
        }
    }

    &.content-header--bordered {
        //padding-bottom: 5rem;
        padding-bottom: 3rem;
        margin-bottom: 3rem;
        border-bottom: 1px solid $border;
    }
}
</style>
